<template>
    <div class="pa-1 ma-1 d-flex flex-row align-center" >
        <div class="ma-1" />

        <v-btn ref="queryConditionSwitchButton" v-if="getQueryConditionSwitchButtonExists()" 
            :color="queryConditionSwitchButtonColor" :class="queryConditionSwitchButtonCssClass" 
            :dark="queryConditionSwitchButtonDark"
            @click="queryConditionSwitchButtonClicked()"
        >
            <v-icon>{{queryConditionSwitchButtonIcon}}</v-icon>
            <span>{{queryConditionSwitchButtonText}}</span>
        </v-btn>

        <div v-if="getQueryConditionSwitchButtonExists()" class="mx-1" />

        <v-btn ref="addLowLevelButton" v-if="getAddLowLevelButtonExists()" class="mr-1"
            :color="addLowLevelButtonColor" :class="addLowLevelButtonCssClass" 
            @click="addLowLevelButtonClicked()"
            >
            <v-icon>{{addLowLevelButtonIcon}}</v-icon>
            <span>{{addLowLevelButtonText}}</span>
        </v-btn>

        <v-btn ref="addSameLevelButton" v-if="getAddSameLevelButtonExists()" class="mr-1"
            :color="addSameLevelButtonColor" :class="addSameLevelButtonCssClass" 
            @click="addSameLevelButtonClicked()"
            >
            <v-icon>{{addSameLevelButtonIcon}}</v-icon>
            <span>{{addSameLevelButtonText}}</span>
        </v-btn>

        <div v-if="getAddLowLevelButtonExists()||getAddSameLevelButtonExists()" class="mx-1" />

        <v-btn ref="createButton" v-if="getCreateButtonExists()" class="mr-1"
            :color="createButtonColor" :class="createButtonCssClass" 
            @click="createButtonClicked()"
            >
            <v-icon>{{createButtonIcon}}</v-icon>
            <span>{{createButtonText}}</span>
        </v-btn>


        <v-btn ref="browseDetailButton" v-if="getBrowseDetailButtonExists()"  class="mr-1"
            :color="browseDetailButtonColor" :class="browseDetailButtonCssClass" 
            @click="browseDetailButtonClicked()"
            :disabled="browseDeatilButtonDisabled()"
            >
            <v-icon>{{browseDetailButtonIcon}}</v-icon>
            <span>{{browseDetailButtonText}}</span>
        </v-btn>

        <div v-if="getCreateButtonExists()||getBrowseDetailButtonExists()" class="mx-1" />

        <v-btn ref="refreshButton" v-if="getRefreshButtonExists()">
            刷新
        </v-btn>

        <v-btn ref="exportButton" v-if="getExportButtonExists()"
            :color="exportButtonColor" :class="exportButtonCssClass" 
            :disabled="exportButtonDisabled()"
            @click="exportClicked">
            <v-icon>{{exportButtonIcon}}</v-icon>
            <span>{{exportButtonText}}</span>            
        </v-btn>

        <div v-if="getRefreshButtonExists()||getExportButtonExists()" class="mx-1" />

        <slot name="append"></slot>
        <!-- 加入插槽 -->
        <!-- 复用的类 引入默认组件，加入插槽 -->
        <!-- 复用方式： -->
        <!-- 1 定义新组件，属性和默认组件一样 -->
        <!-- 2 插入默认组件和插槽，给默认组件传入属性 -->
        <!-- 3 给新增按钮增加监听事件，调用默认组件自定义信号发送出去，新增按钮的状态和默认组件一样处理 -->
    </div>
</template>

<script>
    export default {
        name:'DefaultQueryButtonPane',
        props:['context'],
        data () {
            return {

                name:'DefaultQueryButtonPane',
                bill:null,
                signals:null,
                menuId:null,

            }
        },
        methods:{

            injectContext(context){
                if(context){
                    if(context.bill)
                        this.bill = context.bill;
                    if(context.signals)
                        this.signals = context.signals;
                }
            },
            initComponent(){
                console.log('QueryButtonPane begin init components');

            },
            initSignals(){
                console.log('QueryButtonPane begin init signals');
            },
            getSignals(){
                return this.context.signals;
            },
            getMenuId(){
                return this.bill.menuId;
            },
            getModeHelper(){
                return this.context.modeHelper;
            },
            getQueryResultWorker(){
                return this.context.queryResultWorker;
            },

            getQueryConditionSwitchButtonExists(){
                return this.getModeHelper().getQueryConditionSwitchButtonExists();
            },
            
            getQueryConditionSwitchOpened(){
                return this.getModeHelper().getQueryConditionSwitchOpened();
            },
            getQueryConditionSwitchClosed(){
                return this.getModeHelper().getQueryConditionSwitchClosed();
            },

            

            getQueryButtonExists(){
                return this.getModeHelper().getQueryButtonExists();
            },

            getQueryButtonPermited(){
                return this.getModeHelper().getQueryButtonPermited();
            },

            getAddLowLevelButtonExists(){
                return this.getModeHelper().getAddLowLevelButtonExists();
            },

            getAddLowLevelButtonPermited(){
                return this.getModeHelper().getAddLowLevelButtonPermited();
            },

            getAddSameLevelButtonExists(){
                return this.getModeHelper().getAddSameLevelButtonExists();
            },

            getAddSameLevelButtonPermited(){
                return this.getModeHelper().getAddSameLevelButtonPermited();
            },

            getCreateButtonExists(){
                return this.getModeHelper().getCreateButtonExists();
            },

            getCreateButtonPermited(){
                return this.getModeHelper().getCreateButtonPermited();
            },

            getBrowseDetailButtonExists(){
                return this.getModeHelper().getBrowseDetailButtonExists();
            },

            getBrowseDetailButtonPermited(){
                return this.getModeHelper().getBrowseDetailButtonPermited();
            },

            getRefreshButtonExists(){
                return this.getModeHelper().getRefreshButtonExists();
            },

            getRefreshButtonPermited(){
                return this.getModeHelper().getRefreshButtonPermited();
            },

            getExportButtonExists(){
                return this.getModeHelper().getExportButtonExists();
            },

            getExportButtonPermited(){
                return this.getModeHelper().getExportButtonPermited();
            },

            //button  disabled
            browseDeatilButtonDisabled(){
                return  (!this.getBrowseDetailButtonPermited())
                || (!(this.bill.getQueryPaneFirstSelectedRecord()));
            },  

            exportButtonDisabled(){
                let queryResultPane = this.bill.getQueryResultPane();
                if(queryResultPane && queryResultPane.getRecordTotal){
                    let total = queryResultPane.getRecordTotal();
                    if((total>0)&&(this.getExportButtonPermited()))
                        return false;
                }
                
                return true;
            },  

            //--event--
            //-------------------------------------------------------------
            queryConditionSwitchButtonClicked(){
                let signal = this.getSignals().queryConditionVisiblityChangeAsked;
                signal.dispatch();
            },
            createButtonClicked(){
                let signal = this.getSignals().newBillAsked;
                signal.dispatch();
            },
            exportClicked(){
                let signal = this.getSignals().exportQueryResultAsked;
                signal.dispatch();
            },
            browseDetailButtonClicked(){
                let rec = this.bill.getQueryPaneFirstSelectedRecord();
                if(!rec)
                    return;
                //转化
                let queryResultWorker = this.getQueryResultWorker();
                let newRec =  rec;
                if(queryResultWorker && queryResultWorker.transformQueryResultRec2EditorRec)
                    newRec = queryResultWorker.transformQueryResultRec2EditorRec(rec);
                let signal = this.getSignals().browseBillAsked;
                signal.dispatch(newRec);
            },

        },
        created(){
            console.log("QueryButtonPane mouted");
            console.log(this.context);
            
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
        computed:{

               

            queryConditionSwitchButtonText(){
                if(this.getQueryConditionSwitchOpened()){
                    return "隐藏查询条件";
                }
                return "展开查询条件";
            },
            queryConditionSwitchButtonCssClass(){
                return "round";
            },
            queryConditionSwitchButtonColor(){
                return "purple";
            },
            queryConditionSwitchButtonDark(){
                return true;
            },

            queryConditionSwitchButtonIcon(){
                if(this.getQueryConditionSwitchOpened()){
                    return "mdi-arrow-up-drop-circle-outline";
                }
                return "mdi-arrow-down-drop-circle-outline";
            },
            queryConditionSwitchButtonText(){
                if(this.getQueryConditionSwitchOpened()){
                    return  "隐藏查询条件";
                }
                return  "展开查询条件";
            },
            createButtonIcon(){
                return "mdi-file-outline";
            },
            createButtonText(){
                return "新建";
            },
            createButtonCssClass(){
                if(this.getBrowseDetailButtonExists()){
                    return "left-round";
                }
                return "round";
            },
            createButtonColor(){
                return "primary";
            },
            createButtonDark(){
                return true;
            },

            browseDetailButtonIcon(){
                return "mdi-content-duplicate";
            },
            browseDetailButtonText(){
                return "查看详情";
            },
            browseDetailButtonCssClass(){
                if(this.getCreateButtonExists()){
                    return "right-round";
                }
                return "round";
            },
            browseDetailButtonColor(){
                return "primary";
            },
            browseDetailButtonDark(){
                return true;
            },

            exportButtonIcon(){
                return "mdi-export";
            },
            exportButtonText(){
                return "导出";
            },
            exportButtonCssClass(){
                return "round";
            },
            exportButtonColor(){
                return "success";
            },
            exportButtonDark(){
                return true;
            },

            //---------------------
            addLowLevelButtonIcon(){
                return "mdi-file-outline";
            },
            addLowLevelButtonText(){
                return "审核";
            },
            addLowLevelButtonCssClass(){
                if(this.getAddSameLevelButtonExists()){
                    return "left-round";
                }else{
                    return "round";    
                }
            },
            addLowLevelButtonColor(){
                return "primary";
            },
            addLowLevelButtonDark(){
                return true;
            },

            addSameLevelButtonIcon(){
                return "mdi-file-outline";
            },
            addSameLevelButtonText(){
                return "取消审核";
            },
            addSameLevelButtonCssClass(){
                if(this.getAddLowLevelButtonExists()){
                    return "right-round";
                }else{
                    return "round";    
                }
            },
            addSameLevelButtonColor(){
                return "primary";
            },
            addSameLevelButtonDark(){
                return true;
            },
        }
    }
</script>

</<style>
</style>
